import { render, staticRenderFns } from "./ChatDateTime.vue?vue&type=template&id=2e7ee463&scoped=true&"
import script from "./ChatDateTime.vue?vue&type=script&lang=js&"
export * from "./ChatDateTime.vue?vue&type=script&lang=js&"
import style0 from "./ChatDateTime.vue?vue&type=style&index=0&id=2e7ee463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ee463",
  null
  
)

export default component.exports